// BMWVID-23611 - Exclude "Autosphere carrosserie Angouleme" from PGA group
export const AUTOSPHERE_CARROSSERIE_ANGOULEME = '4717610c-255c-4388-bec0-d2417640ba75';
export const PGA_DEALER_ID_EXCEPTIONS = [AUTOSPHERE_CARROSSERIE_ANGOULEME];

export const groupPGA = '293ecf45-4f68-3bc5-a713-a5887f4c1219';

/** @type {Record<import('types/Dealer').SocialNetworksEnum, string>} */
export const SOCIAL_NETWORKS = {
    FACEBOOK: 'FACEBOOK',
    INSTAGRAM: 'INSTAGRAM',
    YOUTUBE: 'YOUTUBE',
    LINKEDIN: 'LINKEDIN',
    X: 'X'
};
